import MaskedDateInput from './MaskedDateInput.component';

export default MaskedDateInput;
